import { Box, Typography } from "@mui/material";
import "./step-card.scss";

type StepCardProps = {
  imageUrl: string;
  badgeText: string;
  title: string;
  subtitle: string;
};

export default function StepCard({
  imageUrl,
  badgeText,
  title,
  subtitle,
}: StepCardProps) {
  return (
    <Box className="step-card">
      {/* Badge */}
      <Box className="step-card__badge">{badgeText}</Box>

      {/* Image */}
      <Box
        component="img"
        src={imageUrl}
        alt={badgeText}
        className="step-card__image"
      />

      {/* Overlay */}
      <Box className="step-card__overlay">
        <Typography className="step-card__title">{title}</Typography>
        <Typography className="step-card__subtitle">{subtitle}</Typography>
      </Box>
    </Box>
  );
}
